<template>
  <div>
    <div class="pt-2 small_info">
      <h5 class="mb-3">
        {{ $t('lang.transfer.faq_title') }}
      </h5>

      <div
        v-for="(faq, index) in faqs"
        :key="faq.title"
        class="pt-4 pb-3 border-bottom transfer-faqs"
      >
        <h6
          class="details_items mb-3"
          data-toggle="collapse"
          aria-expanded="false"
          :href="'#faq_'+index"
        >
          <i class=" icon-right-dir color_text" />
          {{ faq.title }}
        </h6>
        <span
          :id="'faq_'+index"
          class="collapse small_h6"
          v-html="faq.answer"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQs',

  props: {
    info: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      faqs: [],
    };
  },

  created() {
    const list = this.info;
    list.pop(); // delete the last question, has link to civitatis
    this.faqs = list;
  },
};
</script>

<style scoped>
</style>
